/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 11th 2023, 1:15:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APISERVICEPATHS, useAPIForm } from "lib/api";
import { AITaskInstruction, AITaskInstructionValidationSchema } from "lib/schemas";
import { useDeleteOSItem } from "version-control/services";

const aiTaskInstructionsAPIPath = APISERVICEPATHS.aiTaskInstructions;

const useDeleteAITaskInstructions = () => useDeleteOSItem<AITaskInstruction>(aiTaskInstructionsAPIPath);

interface UseAITaskInstructionsAPIFormAPIFormSpec {
  aiInstructionsFetchId: AITaskInstruction["id"];
  aiInstructionsDefaultValues: AITaskInstruction;
  updateAiInstructionsFromAPICallback: (aiTaskInstructions: AITaskInstruction) => void;
}

const useAITaskInstructionsAPIForm = ({
  aiInstructionsFetchId,
  aiInstructionsDefaultValues,
  updateAiInstructionsFromAPICallback,
}: UseAITaskInstructionsAPIFormAPIFormSpec) => {
  const useAPIFormReturn = useAPIForm<AITaskInstruction>({
    apiServicePath: aiTaskInstructionsAPIPath,
    apiFormDataValidationSchema: AITaskInstructionValidationSchema,
    apiFormDefaultValues: aiInstructionsDefaultValues,
    apiInitialFetchId: aiInstructionsFetchId,
    primaryKey: "id",
    setAPIFormResponse: updateAiInstructionsFromAPICallback,
  });

  return useAPIFormReturn;
};

export const useAIWorkersAPI = () => ({
  useAITaskInstructionsAPIForm,
  useDeleteAITaskInstructions,
});
